const home = {
    'home.video.title': 'Heal Your World.',
    'home.video.btn': 'How It Works',
    'home.pro.learnMore': 'Learn more',
    'home.join.title': 'Join us and move forward together',
    'home.join.btn': 'Become a partner',
    'home.pro.title1': 'Snailcle AI smart bike S1',
    'home.pro.con1': 'Looks smart,spiritual,minimalist design,no hard lines, smooth your soul.',
    'home.pro.btn': 'Discover More',
    'home.pro.title2': 'Self-power AI recumbent bike R1',
    'home.pro.con2': 'Another fat-reducing and fitness beauty product waiting to be discovered that is more suitable for you. It has a cute and compact appearance, and is cute and exquisite in urban home style.',
    'home.pro.title3': 'AI self-power intelligent rowing machine M1',
    'home.pro.con3': `One of Snailcle's healing technology products, a new fitness option. One-click shrink function brings simplicity, fashion and safety back.`,
    'home.app.title': 'Simple and convenient.',
    'home.app.con': 'The Snailcle App takes the guesswork out of working hard. Browse hundreds of guided workouts and programs, review personalized metrics, browse on-the-go workouts, and schedule classes for the coming week.',
    'home.app.btn': 'Explore App',
    'home.brand.title': 'International brand, world standards.',
    'home.brand.con': 'Launch in Japan, Korea,Taiwan, Hong Kong, Southeast Asia.Europe, United States, Middle East markets the same time.',
    'home.price.num': 'USD 899',
    'home.news.title': 'Recent News.',
    'home.news.btn': 'Read More',
    'homeR1.price.num': 'USD 799',
    'homeM1.price.num': 'USD 699',
}
const product = {
    'product.play.btn': 'Play Now',
    'product.title': 'AI smart bike S1',
    'product.banner.title1': 'Snailcle S1 Heal your world .',
    'product.banner.con1': 'Snailcle S1 has a snail-cute appearance and is a fitness product full of warmth, healing and technology.',
    'product.banner.title2': 'Snailcle App with funny riding.',
    'product.banner.con2': 'With support of Snailcle App, you will find random cycling,programs,selectroutes,competition,	coach class etc.which make your riding full of fun.	',
    'product.Exclusive.Features': 'Exclusive Features, work around you! ',
    'product.banner.title3': 'Two styles, there is always something that suits your taste.',
    'product.banner.con3': 'Specification.',
    'product.gifBanner.title1': 'Smart',
    'product.gifBanner.con1': 'Looks different, stands out. Minimalist design, no hard lines. smooth your soul!',
    'product.gifBanner.title2': 'Auto height-adjustable',
    'product.gifBanner.con2': 'Once connected to the power, Snailcle bike will recover the handlebar and seat height to the lowest position for easy step over.',
    'product.gifBanner.title3': 'Slight adjustment',
    'product.gifBanner.con3': 'Even you want slight adjustment,no need to leave the seat, just press buttons on handle bar.',
    'product.gifBanner.title4': 'AI posture detect',
    'product.gifBanner.con4': 'With support of patent gravity sensor identification and AI posture calculation formula, Snailcle bike will detect your body movement posture, and match the most suitable resistance value for you.',
    'product.gifBanner.title5': 'AI posture analysis',
    'product.gifBanner.con5': 'When you move forward, the resistance will incraese automatically.When you sit straight,the resistance will reduce automatically.',
    'product.imgBanner.title1': 'Cycling simulation',
    'product.imgBanner.con1': 'It provides a loop that simulates reality, with more challenging slope simulations, and feels like playing a game.',
    'product.imgBanner.title2': 'Simple ride',
    'product.imgBanner.con2': 'There are no goals, no controls, and of course no limits. This is your free ride. We are only responsible for recording your data.',
    'product.imgBanner.title3': 'Program ride',
    'product.imgBanner.con3': 'In order to meet your practical needs, we have set up a multi-functional cycling program to achieve the desired training effect by controlling resistance and detecting step frequency data.',
    'product.imgBanner.title4': 'Curriculum and Reality',
    'product.imgBanner.con4': 'In the course, there are no restrictions, only professional coaches guide you how to train and accompany you; In real life, apart from the beauty and feeling the real incline, you can completely release yourself and try to complete the route in less time.',
    'product.imgBanner.title5': 'Cycling Data Overview',
    'product.imgBanner.con5': "In addition to the data for each ride, the lighted squares give you a more intuitive sense of how often you've been exercising recently.",
    'product.proList.title1': 'Wide and soft saddle',
    'product.proList.con1': 'Equipped with wide and soft saddle for guaranteed comfort, no matter how long and how fast you pedal,your will feel your workout as pleasant as possible.',
    'product.proList.title2': 'EMS magnetic system',
    'product.proList.con2': 'Specially designed EMS magnetic system with quick response to support smooth pedalling without jerking.',
    'product.proList.title3': 'Dancing tail light',
    'product.proList.con3': 'Tail light color matchs with scroll wheel color, dancing together with your riding. This light also indicates connect or disconnect of Bluetooth.',
    'product.proList2.title1': 'Multi function handlebar',
    'product.proList2.con1': 'A handle bar with 3 positions: Relax,sporty,competition',
    'product.proList2.title2': 'Solid body, maximum range to meet you.',
    'product.proList2.con2': 'User height range:150cm-190cm. Max. user weight:120kg.',
    'product.proList2.title3': 'Sleeping mode',
    'product.proList2.con3': 'If machine is without any operation for 15 minutes, the magnetic system will stop working for energy saving purpose(no more than 24V).',
    'product.specificationList.title1': 'Assembly size:',
    'product.specificationList.title2': 'user weight:',
    'product.specificationList.title3': 'Resistance level:',
    'product.specificationList.title4': 'Max.power:',
    'product.specificationList.title5': 'Power supply:',
    'product.specificationList.title6': 'Handlebar adjustment range&way:',
    'product.specificationList.title7': 'Saddle adjustment range&way:',
    'product.specificationList.con6': '190mm, power adjustment',
    'product.specificationList.con7': '170mm, power/manual adjustment',
    'product.customerReviews': 'Customer Reviews.',
    'productR1.title': 'AI recumbent bike R1',
    'productR1.banner.title1': 'Snailcle R1 Heal your world .',
    'productR1.banner.con1': 'Snailcle R1 is a self-power fitness product full of warmth, healing and technology, suitable for a wider range of people.',
    'productR2.Exclusive.Features': 'Exclusive Features,work around you!',
    'productR1.imgBanner.title1': 'Easy get on',
    'productR1.imgBanner.con1': 'Power length adjustment,releast of 380mm big space. Easy get on and get off,user height range: 1.5m-2m.',
    'productR1.imgBanner.title2': 'Easier adujustment',
    'productR1.imgBanner.con2': 'With length memory system and humanized design, it can accommodatethe individual settings of up to five family members, saving youthe hassle of adjusting each time.',
    'productR1.imgBanner.title3': 'Self-power',
    'productR1.imgBanner.con3': 'The green and environmentally friendly self-powered system is adopted,giving value to exercise. The kinetic energy generated during use can be converted into electrical energy, which can provide continuous and ample power to the machine, and it can also charge external devices such as mobile phones and pads.',
    'productR1.imgBanner.title4': 'Riding more realistic',
    'productR1.imgBanner.con4': "The R1's resistance adopts a PMS electromagnetic control system,which is super quiet, low atency, no stalling, stable and safe. lt can accelerate or decelerate within milliseconds across 1-36 levels, maintaining momentum and efficiency. This provides the feeling of real outdoor bike riding experience to meet the exercise intensity requirements of different people.",
    'productR1.imgBanner.title5': 'Scientifically effective ',
    'productR1.imgBanner.con5': "In addition to having a built-in hand grip heart rate function, the R1 can also connect toa heart rate devices that have a heart rate broadcasting function, including wristbandswatches, heart rate belts, arm bands, etc. The Snailcle APP also has heart ratemonitoring and reminder functions.",
    'productR1.proList.title1': 'Console display',
    'productR1.proList.con1': 'Equipped with wide and soft saddle for guaranteed comfort, no matter how long and how fast you pedal,your will feel your workout as pleasant as possible.',
    'productR1.proList.title2': 'Dual handrail design',
    'productR1.proList.con2': 'Tail light color matchs with scroll wheel color, dancing together with your riding. This light also indicates connect or disconnect of Bluetooth.',
    'productR1.proList2.title1': 'Technology makes exercise no longer challenging',
    'productR1.proList2.con1': 'The Snailcle team has independently developed an app that integratesAl intelligent resistance control, outdoor simulation cycling, visual recognitioninteractive PK challenge mini-games, making exercise no longer dull.',
    'productR1.proList2.title2': 'Seeing you relaxes me, using you lose weight,cure-all tech beauty product',
    'productR1.proList2.con2': 'R1 continues the aesthetic design style of the first generation S1Al fitness bike: adorable, small, and finely styled for the urban homeThe tail lights and the TFT shuttle five-color dynamic breathing lightsplay a finishing touch; the power retractable seat also highlights theunique design philosophy of the Snailcle brand.',
    'productR1.proList2.title3': 'Free to retract and extend, convenient to move',
    'productR1.proList2.con3': 'The unique design concept of the Snailcle brand makes all user operations easy and simple.',
    'productR1.banner.title3': 'The TFT color screen displavstime. distance,caloriesRPM, resistance,power, heart rate monitoring,etcProgram ride, free ride, one-key storage,easyoperation with position memory.External heart rate device connectivity. wirelesscharging,USB charging ports are all available.',
    'productR1.specificationList.information': 'Product information',
    'productR1.specificationList.title1': 'Power: ',
    'productR1.specificationList.con1': '300W',
    'productR1.specificationList.title2': 'Power supply: ',
    'productR1.specificationList.con2': 'Self-power by your movement',
    'productR1.specificationList.title3': ' ',
    'productR1.specificationList.con3': 'No need for an outlet',
    'productR1.specificationList.title4': 'System: ',
    'productR1.specificationList.con4': 'Magnet system',
    'productR1.specificationList.title5': 'Flywheel: ',
    'productR1.specificationList.con5': '5.5kg',
    'productR1.specificationList.title6': 'Resistance level: ',
    'productR1.specificationList.con6': 'Computer controlled 36 levels',
    'productR1.specificationList.title7': 'Saddle up&down: ',
    'productR1.specificationList.con7': 'Air-pressure easy height-adjustable seat to ensure good posture',
    'productR1.specificationList.title8': 'Length adjustment: ',
    'productR1.specificationList.con8': 'By power',
    'productR1.specificationList.title9': 'Console: ',
    'productR1.specificationList.con9': 'Knob LED display',
    'productR1.specificationList.title10': 'Display parameter on console:',
    'productR1.specificationList.con10': 'Resistance level,time, speed,calories,RPM,distance,pulse,watt',
    'productR1.specificationList.title11': 'Programs: ',
    'productR1.specificationList.con11': '12 default training programs',
    'productR1.specificationList.title12': ' ',
    'productR1.specificationList.con12': '3 countdown mode',
    'productR1.specificationList.title13': ' ',
    'productR1.specificationList.con13': '5 self-setting length memory programs',
    'productR1.specificationList.title14': 'App connection: ',
    'productR1.specificationList.con14': 'Snailcle App',
    'productR1.specificationList.title15': 'USB charging port: ',
    'productR1.specificationList.con15': 'Yes',
    'productR1.specificationList.title16': 'Pulse connection: ',
    'productR1.specificationList.con16': 'Yes, with pulse sensor',
    'productR1.specificationList.title17': ' ',
    'productR1.specificationList.con17': 'Supports wireless wearable devices with heart rate broadcasting function',
    'productR1.specificationList.title18': 'Device holder: ',
    'productR1.specificationList.con18': 'Yes',
    'productR1.specificationList.title19': 'User height range: ',
    'productR1.specificationList.con19': '150cm-190cm',
    'productR1.specificationList.title20': 'Max. user weight:',
    'productR1.specificationList.con20': '120kg',
    'productR1.specificationList.title21': 'Assembly min.size:',
    'productR1.specificationList.con21': '1335*652*1218mm',
    'productR1.specificationList.title22': 'Assembly max.size:',
    'productR1.specificationList.con22': '1615*652*1218mm',
    'productR1.specificationList.Package&LoadingQty': 'Package&Loading qty',
    'productR1.specificationList.title26': 'N.W.:',
    'productR1.specificationList.con26': '42kg',
    'productR1.specificationList.title27': 'G.W:',
    'productR1.specificationList.con27': '49kg',
    'productR1.specificationList.title28': 'Carton size:',
    'productR1.specificationList.con28': '1300*355*625mm',
    'productR1.specificationList.title29': '20’/40’/40HQ:',
    'productR1.specificationList.con29': '88 / 189 / 216',
    'productM1.title': 'AI rowing machine M1',
    'productM1.banner.title1': 'Snailcle M1 Heal your world.',
    'productM1.banner.con1': 'Snailcle M1 has a cute and compact appearance and can be stored easily. It is a cute and exquisite urban home fitness product.',
    'productM1.banner.title2': 'Rowing with Snailcle App',
    'productM1.banner.con2': 'With the support of Snailcle App, you can use free rowing, rowing heart rate training and various rowing program course exercises, and record every effort and gain with data.',
    'productM1.imgBanner2.title1': 'Free rowing',
    'productM1.imgBanner2.con1': 'In free rowing, there are no goals and restrictions. The App panel will display real-time data of each paddle to provide you with timely feedback.',
    'productM1.imgBanner2.title2': 'Rowing heart rate training ',
    'productM1.imgBanner2.con2': 'Rowing heart rate training is an exercise method that adjusts training intensity based on setting a heart rate target. In this way, all you need to focus on is your heart rate.',
    'productM1.imgBanner2.title3': 'Program Rowing',
    'productM1.imgBanner2.con3': 'In order to meet your actual needs, we have set up a variety of rowing training programs to achieve the ideal exercise effect by controlling resistance and monitoring rowing frequency data.',
    'productM1.imgBanner.title1': 'New choices for families',
    'productM1.imgBanner.con1': 'The slide rail power movement space of 700MM. From 1.5 to 2 meters,even 300pound strong men can row comfortably.',
    'productM1.imgBanner.title2': 'Simplicity, Fashion, Safety ',
    'productM1.imgBanner.con2': 'With one-button storage, it only takes up 0.5 square meters,creatively solving the issue of traditional rowing machinesbeing too long and difficult to store.',
    'productM1.imgBanner.title3': 'Self-power',
    'productM1.imgBanner.con3': 'The green and environmentally friendly self-powered system is adopted,giving value to exercise. The kinetic energy generated during use can be converted into electrical energy, which can provide continuous and ample power to the machine, and it can also charge external devices such as mobile phones and pads.',
    'productM1.imgBanner.title4': 'Rowing more silent',
    'productM1.imgBanner.con4': "The M1's resistance uses a PMS control system, providing super quietness, low latency, no lag, stable and safe performance. With 16 level resistance choice, it maintains the inertia of movement and high efficiency, achieving the realistic experience of rowing and meeting the intensity requirements of exercise for different groups of people.",
    'productM1.imgBanner.title5': 'Scientifically effective ',
    'productM1.imgBanner.con5': "in addition to having a built-in hand grip heart rate function, the M1 can also connect to all heart rate devices that have a heart rate broadcasting function, including wristbands ,watches, heart rate belts, arm bands, etc. The Snailcle APP also has heart rate monitoring and reminder functions.",
    'productM1.proList2.title1': 'Let creativity heal your world, use technology to eradicateuniformity, bringing therapeutic tech beauty to life',
    'productM1.proList2.con1': 'M1 continues the aesthetic design style of the first generation S1 Alfitness bike: adorable, small, and finely styled for the urban homeThe tail lights and the TFT shuttle five-color dynamic breathinglights play a finishing touch; the power retractable seat alsohighlights the unique design philosophy of the Snailcle brand.',
    'productM1.proList2.title2': 'Free to retract and extend, convenient to move',
    'productM1.proList2.con2': 'The unique design concept of the Snailcle brand makes all user operations easy and simple.',
    'productM1.banner.title3': 'TFT color screen display: time, distance, calories, countSPM, resistance, power, heart rate monitoring, etc.;Program, freedom, one-button storage, easy operationExternal heart rate devices connectivity, equipped wita USB charging interface.',
    'productM1.specificationList.title1': 'Power: ',
    'productM1.specificationList.con1': '300W',
    'productM1.specificationList.title2': 'Power supply: ',
    'productM1.specificationList.con2': 'Self-powered',
    'productM1.specificationList.title3': 'Power storage:',
    'productM1.specificationList.con3': 'Yes, power expansion and contraction',
    'productM1.specificationList.title4': 'Resistance mechanism:',
    'productM1.specificationList.con4': 'Magnet',
    'productM1.specificationList.title5': 'Flywheel: ',
    'productM1.specificationList.con5': '2kg',
    'productM1.specificationList.title6': 'Resistance level: ',
    'productM1.specificationList.con6': 'Computer controlled 16 levels',
    'productM1.specificationList.title7': 'Sliding rail:',
    'productM1.specificationList.con7': 'Aluminium alloy',
    'productM1.specificationList.title8': 'Console: ',
    'productM1.specificationList.con8': 'Knob LED display',
    'productM1.specificationList.title9': 'Display parameter on console:',
    'productM1.specificationList.con9': 'Resistance level,time, calories,distance,pulse,count,SPM',
    'productM1.specificationList.title10': 'Programs: ',
    'productM1.specificationList.con10': '12 default training programs',
    'productM1.specificationList.title11': ' ',
    'productM1.specificationList.con11': '3 countdown mode',
    'productM1.specificationList.title12': 'App connection: ',
    'productM1.specificationList.con12': 'Snailcle App support with funny exercise',
    'productM1.specificationList.title13': 'USB charging port: ',
    'productM1.specificationList.con13': 'Yes',
    'productM1.specificationList.title14': 'Pulse connection: ',
    'productM1.specificationList.con14': 'Yes,system can support with bluetooth wireless wear auto connection to show pulse',
    'productM1.specificationList.title15': 'Device holder: ',
    'productM1.specificationList.con15': 'Yes',
    'productM1.specificationList.title16': 'User height range: ',
    'productM1.specificationList.con16': '150cm-190cm',
    'productM1.specificationList.title17': 'Max. user weight:',
    'productM1.specificationList.con17': '120kg',
    'productM1.specificationList.title18': 'Assembly min.size:',
    'productM1.specificationList.con18': '1188*572*847mm',
    'productM1.specificationList.title19': 'Assembly max.size:',
    'productM1.specificationList.con19': '1784*572*847mm',
    'productM1.specificationList.Package&LoadingQty': 'Package&Loading qty',
    'productM1.specificationList.title20': 'N.W.:',
    'productM1.specificationList.con20': '30kg',
    'productM1.specificationList.title21': 'G.W:',
    'productM1.specificationList.con21': '37kg',
    'productM1.specificationList.title22': 'Carton size:',
    'productM1.specificationList.con22': '1260*355*650mm',
    'productM1.specificationList.title23': '20’/40’/40HQ:',
    'productM1.specificationList.con23': '100 210 / 244',
}
const distributor = {
    'distributor.title': 'Sales Support',
    'distributor.toBecome': 'Partnership for mutual success',
    'distributor.con': 'Regional brand licensing',
    'distributor.con1': 'Co-branding initiatives',
    'distributor.con2': 'Worldwide agent partnership opportunities (Joint Brand Building)',
    'distributor.con3': 'Joint product innovation',
    'distributor.con4': 'Shared technological advancements',
    'distributor.contact': 'Leave your contact details below, we will come back to you as soon as possible.',
    'distributor.phone': 'Telephone:',
    'distributor.email': 'Email:',
    'distributor.workingHours': 'Working Hours:',
    'distributor.workingHours.con': 'BST 9am - 6pm(Mon-Fri)',
    'distributor.join': 'Join us, Snailcle will be your trusted global fitness brand.'
}
const afterSales = {
    'afterSales.title': 'After Sales',
    'afterSales.Video':'Assembly Video.',
    'afterSales.click.download':'click to download:',
    'afterSales.app.download':'App Download.',
    'afterSales.con1':'You can directly search "Snailcle" in Apple & Google play store.',
    'afterSales.con2':'You can also click the button below for more details.',
    'afterSales.Assembly':'Assembly Guide',
    'afterSales.Manual':"User's Manual",
    'afterSales.FunctionGuide': 'Function Guide'
}
const about = {
    'about.title': 'About US',
    'about.Story': 'Brand Story.',
    'about.Story.con1': `Snailcle is an innovative fitness technology company that specilizes in fitness products. Its mission is to create "your first fitness machine" for young families, emphasizing product originality, novelty, intelligence, homogeneity, and content over traditional fitness products that are bulky, dull, and black. SNAILCLE's debut AI-sensing fitness bike S1 was developed by the company's co-founder and partner Dr. Sun Hao from the University of Science and Technology of China, leading a team in innovative concept construction, ID design, advanced multi-dimensional force perception sensors, and AI posture analysis algorithms and morphology recognition algorithms, and was put into mass production in September 2022. In the same year, S1 was first launched on the American crowdfunding platform KICKSTARTER with independent research and development and independent brands, and achieved success. Later, it was sold in markets such as Hong Kong, Taiwan, Korea, Japan, the United States, Germany, Israel, India, and Russia, achieving the first step of international brand strategy.`,
    'about.Story.con2': 'The Snailcle family series products R1 recumbent bike&M1 rowing machine, and future new products will all follow a consistent design style of power lifting, power expansion, and power storage,which inspire all SNAILCLE family products with more distinctive product features.',
    'about.Profile': 'INTRODUCTION',
    'about.technology': 'SNAILCLE (XIAMEN) TECHNOLOGY CO.,LTD',
    'about.join': 'Snailcle has always adhered to the business philosophy of "customer-centered, innovation as the core, and market-oriented" to satisfy users and customers. Snailcle brand will gradually perfect the product line, market channel construction, and brand building, striving to create an international fitness brand for "new fitness, new market, and new users."',
    'about.phone': 'Hot line:',
    'about.email': 'Email:',
    'about.address': 'Address: ',
    'about.address.con': '7th Floor, No.36, Bannan Road, Haicang District,Xiamen, China '
}
const contact = {
    'contact.title': 'Contact us',
    'contact.con1': 'Interested in our products and solutions?',
    'contact.con2': 'Want to buy our products?',
    'contact.con3': 'Become our brand ambassador?',
    'contact.con4': 'Become a distributor?',
    'contact.now': 'Contact us NOW!',
    'contact.message': "We'd love to hear from you. Please use the form to send us your message."
}
const support= {
    'support.title': 'Support',
    'support.con1': 'Please use the Support Form to receive professional help from our specialists. Filling up the formis going to help our team to resolve your issue fast and effectively. Thanks!',
    'support.con2': 'Thank you for purchasing Snailcle Bike！',
    'support.send.email': 'SEND US AN EMAIL:',
    'support.con3': "Ask us anything! We'll get back to you within 24-28 hours.",
    'support.chat': 'CHAT WITH US:',
    'support.con4': 'If you have an issue or question that rquires immediate assistance,you can click below to chat live with a customer service representative.',
    'support.message': 'One Click Message us',
    'support.con5': "If we aren't avaliable,drop us an email to the left and we'll within 24-28 hours.",
}
const shippingPolicy = {
    'shippingPolicy.title': 'Shipping Policy',
    'shippingPolicy.con1': 'Thank you for purchasing Snailcle Bike！',
    'shippingPolicy.con2': 'Our goal is to provide you with the greatest transportation options to enable the product deliver to you quickly and safely. Please pay special attention to the sales region and respective delivery policies.',
    'shippingPolicy.con3': 'The order delivery timeline is separated into two parts:',
    'shippingPolicy.time': 'Processing time:',
    'shippingPolicy.time.con': 'in 48 business hours.',
    'shippingPolicy.method': 'Shipping method:',
    'shippingPolicy.method.con': 'Fedex & UPS & DPD & TNT...',
    'shippingPolicy.ShippingTime': 'Shipping time:',
    'shippingPolicy.ShippingTime.con': '5-7 business days',
    'shippingPolicy.ShippingFee': 'Shipping fee:',
    'shippingPolicy.ShippingFee.con': 'Free shipping order over $ 499',
}
const formType = {
    'form.label.Name': 'Your Name',
    'form.label.Company': 'Your Company Name',
    'form.label.email': 'E-mail',
    'form.label.Comment': 'Your Comment',
    'form.label.Phone': 'Your Phone',
    'form.label.Country': 'Your Country',
    'form.label.Model': 'Product Model',
    'form.label.from': 'Purchase from',
    'form.label.Purchase': 'Proof of Purchase',
    'form.label.Description': 'Description',
    'form.btn.sub': 'Submit Contact',
    'form.message.valid.email': 'The input is not valid E-mail!',
    'form.message.enter.email': 'Please input your E-mail!',
    'form.message.phone': 'Please input your phone number!',
    'form.message.comment': 'Please input your comment',
    'form.message.enter.comment': 'Please leave your comment here',
    'form.message.des': 'Please leave your description here',
    'form.message.des.input': 'Please input your description',
    'form.message.purchase.input': 'Please input your your proof of purchase!',
    'form.message.from': 'Please input your your purchase from!',
    'form.message.Model': 'Please input your your product model!',
}
const whereToBuy = {
    'wheretobuy.title1': 'Purchasing channels',
    'wheretobuy.con': 'Please visit our official purchasing channel.',
    'wheretobuy.title2': 'Other purchasing channels',
    'wheretobuy.Btn': 'Where to buy',
}
const header = {
    'header.menus.home': 'Home',
    'header.menus.product': 'Product',
    'header.menus.news': 'News',
    'header.menus.support': 'Sales Support',
    'header.menus.after': 'After Sales',
    'header.menus.about': 'About Us',
    'header.menus.contact': 'Contact us',
    'header.menus.proS1': 'Snailcle AI smart bike S1',
    'header.menus.proR1': 'AI recumbent bike R1',
    'header.menus.proM1': 'AI rowing machine M1'
}
const footer = {
    'footer.menus.about': 'SUPPORT',
    'footer.menus.about.About': 'Brand Story',
    'footer.menus.about.Contact': 'Contact us',
    'footer.menus.about.Distributor': 'Become A Distributor',
    'footer.menus.support': 'SERVICE',
    'footer.menus.support.Support': 'After Sales Support',
    'footer.menus.support.Shipping': 'Shipping Policy',
    'footer.menus.support.Return': 'Return &Refund Policy',
    'footer.menus.support.Refund': 'Refund Policy',
    'footer.menus.support.Intellectual': 'Intellectual Property Rights',
    'footer.menus.support.Privacy': 'Privacy Policy',
    'footer.menus.support.Terms': 'Terms of Service',
    'footer.menus.INFO': 'INFO',
    'footer.menus.INFO.App': 'App',
    'footer.menus.INFO.News': 'News',
    'footer.menus.INFO.FAQ': 'FAQ',
    'footer.menus.INFO.Installation': 'Assembly Video',
    'footer.SUBSCRIBE': 'SUBSCRIBE To US',
    'footer.enterAddress': 'enter your email address',
    'footer.Submit': 'Submit',
    'footer.pages.news.title': 'Snailcle News',
    'footer.pages.news.publish': 'Publish',
    'footer.pages.Support.title': 'Sales Support',
    'footer.bottom.con': '©2020 酷蜗牛（厦门）科技有限公司 版权所有 闽ICP备2024032604号-1'
}
const download = {
    'download.meta.title': 'Snailcle - Smart Fitness App',
    'download.title': 'Snailcle',
    'download.subtitle': 'Your smart companion for a better fitness journey.',
    'download.status.ios': 'Opening App Store...',
    'download.status.android': 'Opening Google Play...',
    'download.store.apple.small': 'Download on the',
    'download.store.apple.large': 'App Store',
    'download.store.google.small': 'GET IT ON',
    'download.store.google.large': 'Google Play',
    'download.store.action': 'GET',
    'download.qr.ios': 'iOS QR code',
    'download.qr.android': 'Android QR code',
    'download.footer.company': '©{year} SNAILCLE (XIAMEN) TECHNOLOGY CO., LTD.'
}
export default {
    ...home,
    ...product,
    ...distributor,
    ...afterSales,
    ...about,
    ...contact,
    ...support,
    ...shippingPolicy,
    ...formType,
    ...whereToBuy,
    ...header,
    ...footer,
    ...download
}
